import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FilteringComponent } from './filtering.component';
import { FormsModule } from '@angular/forms';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { AcsInputModule } from '../acs-input/acs-input.module';

@NgModule({
    declarations: [FilteringComponent],
    imports: [CommonModule, AcsInputModule, TranslateModule, LocalizeRouterModule, FormsModule],
    providers: [],
    exports: [FilteringComponent]
})
export class FilteringModule {
    constructor() {}
}
